// // src/components/landing/FilterBar.tsx
// import React, { useEffect, useState } from "react";
// import { SlidersHorizontal, RotateCcw } from "lucide-react";
// import { BrandListingFilters } from "../../types/brandlistingsmodel";
// import { MEDIA_TYPE_OPTIONS, PRICE_BOUNDS } from "../../utils/listingFormat";

// function PriceRangeSlider({
//   min,
//   max,
//   value,
//   onChange,
// }: {
//   min: number;
//   max: number;
//   value: [number, number];
//   onChange: (v: [number, number]) => void;
// }) {
//   const [lo, hi] = value;
//   const span = Math.max(max - min, 1);
//   const pctLo = ((lo - min) / span) * 100;
//   const pctHi = ((hi - min) / span) * 100;
//   const step = Math.max(Math.round(span / 100), 500);

//   return (
//     <div>
//       <div className="relative h-1.5 rounded-full bg-slate-200">
//         <div
//           className="absolute h-1.5 rounded-full bg-gradient-to-r from-[#1D9BD8] to-[#EB4A2D]"
//           style={{ left: `${pctLo}%`, right: `${100 - pctHi}%` }}
//         />
//         <input
//           type="range"
//           min={min}
//           max={max}
//           step={step}
//           value={lo}
//           onChange={(e) => onChange([Math.min(Number(e.target.value), hi - step), hi])}
//           className="adroj-range pointer-events-none absolute inset-0 h-1.5 w-full appearance-none bg-transparent"
//         />
//         <input
//           type="range"
//           min={min}
//           max={max}
//           step={step}
//           value={hi}
//           onChange={(e) => onChange([lo, Math.max(Number(e.target.value), lo + step)])}
//           className="adroj-range pointer-events-none absolute inset-0 h-1.5 w-full appearance-none bg-transparent"
//         />
//       </div>
//       <div className="mt-2 flex items-center justify-between text-[11px] font-medium text-slate-500">
//         <span>{`\u20B9${lo.toLocaleString("en-IN")}`}</span>
//         <span>{`\u20B9${hi.toLocaleString("en-IN")}`}</span>
//       </div>
//     </div>
//   );
// }

// export function FilterBar({
//   filters,
//   onChange,
//   resultCount,
//   isLoading,
// }: {
//   filters: BrandListingFilters;
//   onChange: (next: BrandListingFilters) => void;
//   resultCount: number;
//   isLoading: boolean;
// }) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [stateInput, setStateInput] = useState(filters.state ?? "");
//   const [cityInput, setCityInput] = useState(filters.city ?? "");
//   const [price, setPrice] = useState<[number, number]>([
//     filters.minRent ?? PRICE_BOUNDS[0],
//     filters.maxRent ?? PRICE_BOUNDS[1],
//   ]);

//   // Debounce free-text State/City so we don't fire a request per keystroke.
//   useEffect(() => {
//     const t = setTimeout(() => {
//       if (stateInput !== (filters.state ?? "")) {
//         onChange({ ...filters, state: stateInput || undefined });
//       }
//     }, 450);
//     return () => clearTimeout(t);
  
//   }, [stateInput]);

//   useEffect(() => {
//     const t = setTimeout(() => {
//       if (cityInput !== (filters.city ?? "")) {
//         onChange({ ...filters, city: cityInput || undefined });
//       }
//     }, 450);
//     return () => clearTimeout(t);
    
//   }, [cityInput]);

//   useEffect(() => {
//     const t = setTimeout(() => {
//       onChange({
//         ...filters,
//         minRent: price[0] > PRICE_BOUNDS[0] ? price[0] : undefined,
//         maxRent: price[1] < PRICE_BOUNDS[1] ? price[1] : undefined,
//       });
//     }, 350);
//     return () => clearTimeout(t);
    
//   }, [price]);

//   const reset = () => {
//     setStateInput("");
//     setCityInput("");
//     setPrice(PRICE_BOUNDS);
//     onChange({});
//   };

//   const inputClass =
//     "w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:border-[#1D9BD8] focus:outline-none focus:ring-2 focus:ring-[#1D9BD8]/15";

//   const body = (
//     <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
//       <div>
//         <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">State</label>
//         <input
//           className={inputClass}
//           placeholder="e.g. Uttar Pradesh"
//           value={stateInput}
//           onChange={(e) => setStateInput(e.target.value)}
//         />
//       </div>

//       <div>
//         <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">City</label>
//         <input
//           className={inputClass}
//           placeholder="e.g. Lucknow"
//           value={cityInput}
//           onChange={(e) => setCityInput(e.target.value)}
//         />
//       </div>

//       <div>
//         <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">Media type</label>
//         <select
//           className={inputClass}
//           value={filters.mediaType ?? ""}
//           onChange={(e) => onChange({ ...filters, mediaType: e.target.value || undefined })}
//         >
//           <option value="">All types</option>
//           {MEDIA_TYPE_OPTIONS.map((m) => (
//             <option key={m.value} value={m.value}>
//               {m.label}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div>
//         <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">
//           Total price range
//         </label>
//         <PriceRangeSlider min={PRICE_BOUNDS[0]} max={PRICE_BOUNDS[1]} value={price} onChange={setPrice} />
//       </div>
//     </div>
//   );

//   return (
//     <section className="sticky top-0 z-30 border-y border-slate-100 bg-gradient-to-b from-[#dee9f7] to-white backdrop-blur sm:top-[89px]">
//       <div className="mx-auto max-w-7xl px-5 py-4 sm:px-8">
//         <div className="flex items-center justify-between lg:hidden">
//           <button onClick={() => setMobileOpen((o) => !o)} className="flex items-center gap-2 text-sm font-semibold text-black">
//             <SlidersHorizontal className="h-4 w-4" /> Filters
//           </button>
//           <span className="text-xs text-slate-500">{isLoading ? "Loading..." : `${resultCount} spaces`}</span>
//         </div>

//         <div className={`${mobileOpen ? "mt-4 block" : "hidden"} lg:mt-0 lg:block`}>
//           {body}
//           <div className="mt-4 flex items-center justify-between">
//             <button onClick={reset} className="flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-[#0F172A]">
//               <RotateCcw className="h-3.5 w-3.5" /> Reset filters
//             </button>
//             <span className="hidden text-xs text-slate-800 lg:inline">
//               {isLoading ? "Loading..." : `${resultCount} spaces match`}
//             </span>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
//




//=============================================



// src/components/landing/FilterBar.tsx
import React, { useEffect, useState } from "react";
import { SlidersHorizontal, RotateCcw } from "lucide-react";
import { BrandListingFilters } from "../../types/brandlistingsmodel";
import { MEDIA_TYPE_OPTIONS, PRICE_BOUNDS } from "../../utils/listingFormat";

function PriceRangeSlider({
  min,
  max,
  value,
  onChange,
}: {
  min: number;
  max: number;
  value: [number, number];
  onChange: (v: [number, number]) => void;
}) {
  const [lo, hi] = value;
  const span = Math.max(max - min, 1);
  const pctLo = ((lo - min) / span) * 100;
  const pctHi = ((hi - min) / span) * 100;
  const step = Math.max(Math.round(span / 100), 500);

  return (
    <div>
      <div className="relative h-1.5 rounded-full bg-slate-200">
        <div
          className="absolute h-1.5 rounded-full bg-gradient-to-r from-[#1D9BD8] to-[#EB4A2D]"
          style={{ left: `${pctLo}%`, right: `${100 - pctHi}%` }}
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={lo}
          onChange={(e) => onChange([Math.min(Number(e.target.value), hi - step), hi])}
          className="adroj-range pointer-events-none absolute inset-0 h-1.5 w-full appearance-none bg-transparent"
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={hi}
          onChange={(e) => onChange([lo, Math.max(Number(e.target.value), lo + step)])}
          className="adroj-range pointer-events-none absolute inset-0 h-1.5 w-full appearance-none bg-transparent"
        />
      </div>
      <div className="mt-2 flex items-center justify-between text-[11px] font-medium text-slate-500">
        <span>{`\u20B9${lo.toLocaleString("en-IN")}`}</span>
        <span>{`\u20B9${hi.toLocaleString("en-IN")}`}</span>
      </div>
    </div>
  );
}

export function FilterBar({
  filters,
  onChange,
  resultCount,
  isLoading,
}: {
  filters: BrandListingFilters;
  onChange: (next: BrandListingFilters) => void;
  resultCount: number;
  isLoading: boolean;
}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [stateInput, setStateInput] = useState(filters.state ?? "");
  const [cityInput, setCityInput] = useState(filters.city ?? "");
  const [price, setPrice] = useState<[number, number]>([
    filters.minRent ?? PRICE_BOUNDS[0],
    filters.maxRent ?? PRICE_BOUNDS[1],
  ]);

  // Debounce free-text State/City so we don't fire a request per keystroke.
  useEffect(() => {
    const t = setTimeout(() => {
      if (stateInput !== (filters.state ?? "")) {
        onChange({ ...filters, state: stateInput || undefined });
      }
    }, 450);
    return () => clearTimeout(t);
  
  }, [stateInput]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (cityInput !== (filters.city ?? "")) {
        onChange({ ...filters, city: cityInput || undefined });
      }
    }, 450);
    return () => clearTimeout(t);
    
  }, [cityInput]);

  useEffect(() => {
    const t = setTimeout(() => {
      onChange({
        ...filters,
        minRent: price[0] > PRICE_BOUNDS[0] ? price[0] : undefined,
        maxRent: price[1] < PRICE_BOUNDS[1] ? price[1] : undefined,
      });
    }, 350);
    return () => clearTimeout(t);
    
  }, [price]);

  const reset = () => {
    setStateInput("");
    setCityInput("");
    setPrice(PRICE_BOUNDS);
    onChange({});
  };

  const inputClass =
    "w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 focus:border-[#1D9BD8] focus:outline-none focus:ring-2 focus:ring-[#1D9BD8]/15";

  const body = (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">State</label>
        <input
          className={inputClass}
          placeholder="e.g. Uttar Pradesh"
          value={stateInput}
          onChange={(e) => setStateInput(e.target.value)}
        />
      </div>

      <div>
        <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">City</label>
        <input
          className={inputClass}
          placeholder="e.g. Lucknow"
          value={cityInput}
          onChange={(e) => setCityInput(e.target.value)}
        />
      </div>

      <div>
        <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">Media type</label>
        <select
          className={inputClass}
          value={filters.mediaType ?? ""}
          onChange={(e) => onChange({ ...filters, mediaType: e.target.value || undefined })}
        >
          <option value="">All types</option>
          {MEDIA_TYPE_OPTIONS.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="mb-1 block text-[11px] font-semibold uppercase tracking-wide text-slate-800">
          Total price range
        </label>
        <PriceRangeSlider min={PRICE_BOUNDS[0]} max={PRICE_BOUNDS[1]} value={price} onChange={setPrice} />
      </div>
    </div>
  );

  return (
    <section className="border-y border-slate-100 bg-gradient-to-b from-[#dee9f7] to-white backdrop-blur">
      <div className="mx-auto max-w-7xl px-5 py-4 sm:px-8">
        <div className="flex items-center justify-between lg:hidden">
          <button onClick={() => setMobileOpen((o) => !o)} className="flex items-center gap-2 text-sm font-semibold text-black">
            <SlidersHorizontal className="h-4 w-4" /> Filters
          </button>
          <span className="text-xs text-slate-500">{isLoading ? "Loading..." : `${resultCount} spaces`}</span>
        </div>

        <div className={`${mobileOpen ? "mt-4 block" : "hidden"} lg:mt-0 lg:block`}>
          {body}
          <div className="mt-4 flex items-center justify-between">
            <button onClick={reset} className="flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-[#0F172A]">
              <RotateCcw className="h-3.5 w-3.5" /> Reset filters
            </button>
            <span className="hidden text-xs text-slate-800 lg:inline">
              {isLoading ? "Loading..." : `${resultCount} spaces match`}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}